import apiClient from './apiClient';

// Types for user data
export interface User {
  id: string;
  walletAddress: string;
  balance: number;
  createdAt: string;
  history: UserTransaction[];
}

export interface UserTransaction {
  id: string;
  type: 'credit' | 'debit';
  amount: number;
  oldBalance: number;
  newBalance: number;
  timestamp: string;
}

// User service
const userService = {
  // Get or create user
  getOrCreateUser: async (walletAddress: string): Promise<User> => {
    try {
      const response = await apiClient.post('/users', { walletAddress });
      return response.data.data.user;
    } catch (error) {
      console.error('Error getting/creating user:', error);
      throw error;
    }
  },

  // Get user by wallet address
  getUser: async (walletAddress: string): Promise<User> => {
    try {
      const response = await apiClient.get(`/users/${walletAddress}`);
      return response.data.data.user;
    } catch (error) {
      console.error('Error getting user:', error);
      throw error;
    }
  },

  // Add balance to user (for demo purposes)
  addBalance: async (walletAddress: string, amount: number): Promise<User> => {
    try {
      const response = await apiClient.post('/users/balance/add', { walletAddress, amount });
      return response.data.data.user;
    } catch (error) {
      console.error('Error adding balance:', error);
      throw error;
    }
  },

  // Get all users (for admin/demo purposes)
  getAllUsers: async (): Promise<User[]> => {
    try {
      const response = await apiClient.get('/users');
      return response.data.data.users;
    } catch (error) {
      console.error('Error getting all users:', error);
      throw error;
    }
  }
};

export default userService; 